import React, { useState, useEffect } from 'react';

export const RegionalPremierAds = () => {
  const [premierAuctioneers, setPremierAuctioneers] = useState([]);
  const [location, setLocation] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRegionalPremier();
  }, []);

  const fetchRegionalPremier = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/auctioneers/regional-premier-ads`
      );
      const data = await response.json();
      
      setLocation(data.visitor_location);
      setPremierAuctioneers(data.premier_auctioneers);
    } catch (err) {
      console.error('Failed to fetch regional ads:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading || premierAuctioneers.length === 0) return null;

  return (
    <div className="bg-gradient-to-br from-yellow-50 to-orange-50 border-2 border-yellow-300 rounded-lg p-6 shadow-lg">
      <div className="flex items-center mb-4">
        <span className="text-3xl mr-3">🏆</span>
        <div>
          <h3 className="text-xl font-bold text-gray-900">
            Premier Auctioneers in {location?.state}
          </h3>
          <p className="text-sm text-gray-600">Featured verified professionals</p>
        </div>
      </div>

      <div className="space-y-3 mb-4">
        {premierAuctioneers.map((auctioneer, idx) => (
          <a
            key={idx}
            href={`/find-auctioneer?id=${auctioneer.id}`}
            className="block bg-white rounded-lg p-4 hover:shadow-md transition border border-yellow-200"
          >
            <div className="flex items-start">
              {auctioneer.logo_url && (
                <img
                  src={`${process.env.REACT_APP_BACKEND_URL}${auctioneer.logo_url}`}
                  alt={auctioneer.name}
                  className="w-12 h-12 rounded object-cover mr-3"
                />
              )}
              <div className="flex-1">
                <div className="flex items-center">
                  <h4 className="font-semibold text-gray-900">{auctioneer.name}</h4>
                  <span className="ml-2 px-2 py-0.5 bg-yellow-400 text-yellow-900 text-xs font-bold rounded">PREMIER</span>
                </div>
                <p className="text-sm text-gray-600">{auctioneer.city}, {auctioneer.state}</p>
                {auctioneer.marketing_tagline && (
                  <p className="text-xs text-gray-500 mt-1">{auctioneer.marketing_tagline}</p>
                )}
                {auctioneer.specialties && auctioneer.specialties.length > 0 && (
                  <div className="flex flex-wrap gap-1 mt-2">
                    {auctioneer.specialties.slice(0, 3).map((spec, i) => (
                      <span key={i} className="px-2 py-0.5 bg-blue-50 text-blue-700 text-xs rounded">
                        {spec}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </a>
        ))}
      </div>

      <div className="bg-white border-2 border-dashed border-yellow-400 rounded-lg p-4 text-center">
        <p className="text-sm font-semibold text-gray-900 mb-2">
          🎯 Want YOUR listing here?
        </p>
        <p className="text-xs text-gray-600 mb-3">
          Get top position in search results • Only $4.99/month
        </p>
        <a
          href="/auctioneer/individual/login"
          className="inline-block px-4 py-2 bg-green-600 text-white text-sm font-semibold rounded-lg hover:bg-green-700"
        >
          Upgrade to Premier
        </a>
      </div>
    </div>
  );
};
